<template>
  <font-awesome-icon
    :icon="{ prefix: 'fas', iconName: 'paperclip' }" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPaperclip } from '@fortawesome/free-solid-svg-icons'

library.add(faPaperclip)

export default {
  name: 'CoozzyPaperClipIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
